import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Link } from "@mui/material";


export default function ReactRouterLink(props) {
    const { underline, ...otherProps } = props; 
    return <Link variant="body1" {...otherProps} underline="none" component={RouterLink} />;
}